module.exports = __webpack_public_path__ + "static/media/realtime-tracking.8697dd28.svg";